<template>
  <not-logged-in-view>
    <b-form-group v-if="sent">
      <b-alert variant="secondary" :show="sent" class="mb-5">
        Password has been reset successfully. Please check your E-mail.
        <router-link :to="{ name: 'signIn' }">
          Sign in.
        </router-link>
      </b-alert>
    </b-form-group>
    <b-form v-else lazy-validation novalidate @submit.prevent="submit">
      <b-form-group>
        <h2>Reset password</h2>
      </b-form-group>
      <form-field-template :validator="$v.email" label="E-mail" class="form-group--text">
        <b-form-input v-model="email" name="email" @input="onInput" />
        <ValidationMessage
          v-if="!!errors.email"
          :message="errors.email"
          class="form-group__message--show"
        />
      </form-field-template>
      <b-form-group class="text-center">
        <b-button type="submit" :disabled="$v.email.$invalid" class="sign-in__button btn-secondary">
          Submit
        </b-button>
        <div class="mt-3">
          <router-link :to="{ name: 'signIn' }">
            Cancel
          </router-link>
        </div>
      </b-form-group>
    </b-form>
  </not-logged-in-view>
</template>

<script>
import { email, required } from 'vuelidate/lib/validators';
import NotLoggedInView from '@/components/shared/not-logged-in-view';
import FormFieldTemplate from '@/components/shared/form-field-template';
import FormMixins from '@/components/mixins/form-mixins';

export default {
  name: 'ResetPassword',
  components: { NotLoggedInView, FormFieldTemplate },
  mixins: [FormMixins],
  data() {
    return {
      sent: false,
      email: '',
      errors: {}
    };
  },
  validations: {
    email: {
      email,
      required
    }
  },
  methods: {
    onInput() {
      this.errors = {};
      this.$v.email.$touch();
    },
    onSuccess() {
      this.sent = true;
    },
    submit() {
      this.errors = {};
      this.$store
        .dispatch('passwords/reset', { email: this.email })
        .then(this.onSuccess, this.handleRequestError);
    }
  }
};
</script>
